var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-light-bg",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3666789,3 L3.70001221,3 L3.70001221,5 L4.36634554,5 C4.36634554,4.60866667 4.49867887,4 5.03334554,4 L6.36667887,4 L6.36667887,9.62466667 C6.36667887,10.016 6.09167887,10.3333333 5.70001221,10.3333333 L5.36667887,10.3333333 L5.36667887,11 L8.69967887,11 L8.69967887,10.3333333 L8.36667887,10.3333333 C7.97534554,10.3333333 7.70001221,10.016 7.70001221,9.62466667 L7.70001221,4 L9.03334554,4 C9.58301221,4 9.70667887,4.60866667 9.70667887,5 L10.3666789,5 L10.3666789,3 Z",
    id: "Shape",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightBg);
export default __webpack_public_path__ + "static/media/icon-light-bg.7948964d310114ef0de5c76e9c7e6ee2.svg";
export { ForwardRef as ReactComponent };